import { createTheme } from '@mui/material/styles'

const defaultTheme = createTheme()

export default defaultTheme